/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function () {
  const triggerElements = document.querySelectorAll(".member-block__list > li");
  const visualElements = document.querySelectorAll(
    ".member-block__visual > li",
  );
  if (triggerElements.length === 0) {
    return;
  }

  triggerElements.forEach((element) => {
    element.addEventListener("mouseenter", function () {
      const index = this.dataset.index;
      console.log(index);

      visualElements.forEach((element) => {
        element.classList.remove("is-active");
      });
      const activeElement = document.querySelector(
        ".member-block__visual > li[data-index='" + index + "']",
      );
      console.log(activeElement);
      if (activeElement) {
        activeElement.classList.add("is-active");
      }
    });
  });
});
